import FanSubscribeTypeRadioButtonComponent from "./FanSubscribeTypeRadioButtonComponent";

export default FanSubscribeTypeRadioButtonComponent;
